import React from 'react';
import classNames from 'classnames';
import styles from './comparison-table.module.scss';
import { Content } from '@prismicio/client';

type ColumnSelectButtonsProps = {
    colVisibleOnMobile: 2 | 3;
    tableColCount: number;
    headerRow: Content.ComparisonTableRowSlice;
    toggleColumn: () => Promise<void>;
};

export const ColumnSelectButtons = ({
    tableColCount,
    colVisibleOnMobile,
    headerRow,
    toggleColumn,
}: ColumnSelectButtonsProps) => {
    const selectedTextColor = 'black';
    const unselectedTextColor = 'text-grey-400';

    return (
        <>
            {tableColCount > 2 && (
                <div
                    className={classNames(
                        styles['column-button-group'],
                        colVisibleOnMobile === 2
                            ? 'before:left-0'
                            : 'before:left-[50%]',
                    )}
                >
                    <button
                        onClick={() => toggleColumn()}
                        aria-pressed={colVisibleOnMobile === 2}
                        aria-label="shows column 2 and hides column 3 of the table"
                        className={classNames(
                            colVisibleOnMobile === 2
                                ? selectedTextColor
                                : unselectedTextColor,
                        )}
                    >
                        {headerRow.items[1].cell_text ?? 'Column 2'}
                    </button>
                    <button
                        onClick={() => toggleColumn()}
                        aria-pressed={colVisibleOnMobile === 3}
                        aria-label="shows column 3 and hides column 2 of the table"
                        className={classNames(
                            colVisibleOnMobile === 3
                                ? selectedTextColor
                                : unselectedTextColor,
                        )}
                    >
                        {headerRow.items[2].cell_text ?? 'Column 3'}
                    </button>
                </div>
            )}
        </>
    );
};
